import React, { useState, useEffect } from 'react';
import './App.css';

function App() {
  const [statusData, setStatusData] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStatus = async () => {
      try {
        const response = await fetch('/api/status');
        const data = await response.json();
        setStatusData(data);
      } catch (error) {
        console.error("Failed to fetch status:", error);
      } finally {
        setLoading(false);
      }
    };
    
    fetchStatus();
    const interval = setInterval(fetchStatus, 30000);
    return () => clearInterval(interval);
  }, []);

  if (loading) {
    return <div className="loading">Loading status...</div>;
  }

  return (
    <div className="app-container">
      <header>
        <img id="brand-logo" src="/logos/boxmadness_logo_light.png" alt="Boxmadness Logo" />
      </header>
      <main>
        {Object.entries(statusData).map(([brandName, services]) => (
          <section key={brandName} className="brand-section">
            <h2 className="brand-name">{brandName.charAt(0).toUpperCase() + brandName.slice(1)}</h2>
            <div className="service-list">
              {Object.entries(services).map(([serviceName, status]) => (
                <div key={serviceName} className="service-item">
                  <span className="service-name">{serviceName}</span>
                  <div className="status-indicator">
                    <div className={`status-dot ${status.status.startsWith('live') ? 'live' : 'down'}`}></div>
                    <span className="status-text">{status.status.startsWith('live') ? 'Live' : 'Down'}</span>
                    {status.latency > 0 && <span className="latency">({status.latency}ms)</span>}
                  </div>
                </div>
              ))}
            </div>
          </section>
        ))}
      </main>
	<footer>
		<p>Last checked: {
			Object.values(statusData)[0]?.['frontend']?.last_checked 
			? new Date(Object.values(statusData)[0]['frontend'].last_checked).toLocaleTimeString()
			: 'Loading...'
		}</p>
	</footer>
    </div>
  );
}

export default App;
